import { render, staticRenderFns } from "./GrupoCompraRespostaProdutos.vue?vue&type=template&id=02cbbaec&scoped=true&"
import script from "./GrupoCompraRespostaProdutos.vue?vue&type=script&lang=js&"
export * from "./GrupoCompraRespostaProdutos.vue?vue&type=script&lang=js&"
import style0 from "./GrupoCompraRespostaProdutos.vue?vue&type=style&index=0&id=02cbbaec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cbbaec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
